import React from 'react';
import { SectionCard } from '../common/SectionCard';
import { MEGA_MAJOR_STAGES, STAGE_META } from '../../utils/stages';
import { formatAed } from '../../utils/format';
import type { ApplicationRecord } from '../../types/domain';
export function SupportByStage({
  records
}: {
  records: ApplicationRecord[];
}) {
  const megaMajor = records.filter(record => record.track !== 'international');
  const rows = MEGA_MAJOR_STAGES.map(stage => {
    const inStage = megaMajor.filter(record => record.stage === stage);
    return {
      stage,
      label: STAGE_META[stage].label,
      count: inStage.length,
      aed: inStage.reduce((sum, record) => sum + record.requestedSupportAed, 0)
    };
  });
  const max = Math.max(...rows.map(row => row.aed), 1);
  const total = rows.reduce((sum, row) => sum + row.aed, 0);
  return <SectionCard title="Support envelope by stage" description={`${formatAed(total)} requested across Mega & Major records`} data-id="element-661" data-mp="3bkd05l1p8fp1">
      <ul className="space-y-3" data-id="element-662" data-mp="3foknbdsidnl5">
        {rows.map((row, index) => <li key={row.stage} data-id="element-663" data-mp="2tmwx11jc0wec" data-mpi={index}>
            <div className="flex items-baseline justify-between gap-3" data-id="element-664" data-mp="2oolmspp4kjvl">
              <span className="text-[12px]" data-id="element-665" data-mp="2opeovdd52l7e">
                <span className="mr-1.5 font-mono text-[10px] text-muted-foreground" data-id="element-666" data-mp="2joz8ecxk8xl7">
                  {index + 1}
                </span>
                {row.label}
                <span className="ml-1.5 text-muted-foreground" data-id="element-667" data-mp="2fq9mtx2dc9qh">({row.count})</span>
              </span>
              <span className="font-mono text-[11px]" data-id="element-668" data-mp="2aqn81j6w6lfk">{formatAed(row.aed)}</span>
            </div>
            <div className="mt-1 h-2 w-full overflow-hidden rounded-sm bg-muted" data-id="element-669" data-mp="25wao781i783a">
              <div className="h-full rounded-sm" style={{
            width: `${row.aed / max * 100}%`,
            background: index % 2 === 0 ? 'var(--chart-1)' : 'var(--chart-3)'
          }} data-id="element-670" data-mp="20wy3asu70b3c" />
            </div>
          </li>)}
      </ul>
    </SectionCard>;
}